import { Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import * as moment from 'moment';
import { getParseJson } from '../../../../utils/helpers';
import { downloadFileFromUrl } from 'app/utils/trip2-query-builder/utils/helpers';

@Component({
  selector: 'app-on-demand-drivers-background-check',
  templateUrl: './background-check.component.html',
  styleUrls: ['./background-check.component.scss']
})

export class BackgroundCheckComponent implements OnInit, OnDestroy, OnChanges {

  @Input() selected: number;
  @Input() showReportDate = true;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();

  public reports: any[] = [];
  public selectedReport: any;
  public selectedDataReport: any;
  public showLoading = false;
  private subscrip: Subscription[] = [];
  public noReportsFound = false;

  constructor(
    protected service: OnDemandDriversService,
    private _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
    ) {}


  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selected'] && this.selected) {
      this.getComboData();
    }
  }

  /**
   * @name cancelCreateEdit
   * @description
   */
  public cancelCreateEdit() {
    this.cancel.emit(true);
  }

  /**
   * @name getComboData
   * @description
   */
  private getComboData() {
    this.t2LoadingService.show();
    this.subscrip.push(this.service
    .getReports(this.selected)
    .subscribe(
      data => {
        this.t2LoadingService.hiden();
        this.loadData(data);
      },
      error => {
        this.t2LoadingService.hiden();
        this.sweetAlertHelper.createCustomAlert({
          title: 'Checkr Report',
          text: error.message,
          type: 'error'
        });
      }
    ));
  }

  /**
   * @name retrieveData
   * @description
   * @param reportid
   */
  private retrieveData(reportid) {
    this.subscrip.push(this.service
    .getReportInfo(reportid)
    .subscribe(
      data => this.loadDataReport(data)
    ));
  }

  /**
   * @name loadDataReport
   * @description
   * @param data
   */
  private loadDataReport(data) {
    if (data.error) {
      this.sendNotify(data);
      return;
    }
    this.selectedDataReport = data;
  }

  /**
   * @name onReportDateChange
   * @description
   * @param event
   */
  public onReportDateChange(event) {
    this.retrieveData(event.reportid);
  }

  /**
   * @name runBackgroundCheck
   * @description
   */
  public runBackgroundCheck() {
    this.showLoading = true;
    this._loading.show('Loading Background Check');
    this.showLoading = true;
    this.subscrip.push(this.service.runBackgroundCheck(this.selected).subscribe(
      (success) => {
        if (success.trip2drivercheckrs[0].successful) {
          this.messageBackgroundCheck('Successful',  'success');
        } else {
          this.messageBackgroundCheck(success.trip2drivercheckrs[0].error,  'error');
        }
        this.showLoading = false;
        this.getComboData();
        this._loading.hiden();
      },
      error => {

        this.showLoading = false;
        this._loading.hiden();

        let message = error.message;
        let parseJson = getParseJson(message);

        if(parseJson && parseJson.error){
          message = parseJson.error.toString();
        }

        this.messageBackgroundCheck(message,  'error');
      }
    ));
  }
  messageBackgroundCheck(text: string, type: any): void {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Background Check',
      text: text,
      type: type
    });
  }

  /**
   * @name sendNotify
   * @description
   * @param data
   */
  private sendNotify(data: any) {
    this.notify.emit(data);
  }

  /**
   * @name loadData
   * @description Recibe los datos del servicio y los organiza para su uso
   */
  private loadData(data: any[]) {
    this.reports = data;
    if (data.length > 0) {
      this.selectedReport = data[0];
      this.retrieveData(this.selectedReport.reportid);
    }
    else {
      this.noReportsFound = true;
    }
  }

  changeActiveState() {
    if (this.selectedReport) {
      const obj = {
        drivercheckrid: this.selectedReport.drivercheckrid,
        isactive: this.selectedReport.isactive,
        driverid: this.selectedReport.driverid,
      };
      this.subscrip.push(
        this.service.updateActive(obj).subscribe(
          (resp: any) => {
            if (resp) {
              this.sweetAlertHelper
                .createCustomAlert({
                  title: 'success',
                  text: resp.message,
                  type: 'success',
                })
                .then(() => {
                  this.getComboData();
                });
            }
          },
          (error) => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error',
              text: error.message,
              type: 'error',
            });
          }
        )
      );
    }
  }

  public downloadReport(report: any) {
    if (report.documents) {
      const doc = report.documents.find((d: any) => d.type === 'pdf_report');
      if (doc) {
        downloadFileFromUrl(doc.download_uri);
      }
    } else {
      this.sweetAlertHelper.captureException('Report not available');
    }
  }

  get disabledBtn(): boolean {
    if (this.showLoading || !this.reports || !this.reports.length) {
      return false;
    }
    const [firstPosition] = this.reports;
    return !!firstPosition.iscurrent;
  }

  get turnaroundTime(): string {
    return this.selectedDataReport ? moment.utc(moment.duration(this.selectedDataReport.turnaround_time,'s').asMilliseconds()).format('HH:mm:ss'): '';
  }

  get disabledButtonDownloadReport(): boolean {
    return !this.selectedDataReport || !this.selectedDataReport.documents || !this.selectedDataReport.documents.length;
  }

  classColor(status: string): string {
    return `checkr-${status}`;
  }

  ngOnDestroy(): void {
    this.subscrip.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/background-check/background-check.component.ts